import { createQuery } from '@tanstack/svelte-query';
import { fetchUnits } from '$lib/api/unit';
import type { Unit } from '$lib/types/unit';
import { resolveScope, getProjectScope, type ScopeFn } from './scope';

export const allUnitsQueryKey = ['units', 'all'] as const;

export const allUnitsQuery = () =>
	createQuery<Array<Unit>>(() => ({
		queryKey: allUnitsQueryKey,
		queryFn: () => fetchUnits()
	}));

export function unitsQueryKey(projectId: number) {
	return ['units', { projectId }] as const;
}

export function unitsQueryOptions(projectId: number) {
	return {
		queryKey: unitsQueryKey(projectId),
		queryFn: async () => {
			const all = await fetchUnits();
			return all.filter((u) => u.project === projectId);
		},
		enabled: projectId > 0
	};
}

export const unitsQuery = (scope: ScopeFn = getProjectScope()) =>
	createQuery<Array<Unit>>(() => {
		const projectId = resolveScope(scope);
		return unitsQueryOptions(projectId);
	});
